var React = require('react');

function Application (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM13.2,15.5H2.8c-1.2,0-2.3-1-2.3-2.3V2.8c0-1.2,1-2.3,2.3-2.3h10.5c1.2,0,2.3,1,2.3,2.3v10.5C15.5,14.5,14.5,15.5,13.2,15.5z","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","r":"5.8","key":1}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","r":"1.4","key":2}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t14.8,14.8 8,0.6 1.2,14.8 \t","key":3}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t5.5,10.5 8,12 10.5,10.5 \t","key":4})]));
}

Application.displayName = "Application";

Application.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Application;

Application.default = Application;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/application.svg
// module id = ../icon/src/icons/application.svg
// module chunks = 0